<template>
  <div class="float-w show" v-if="isShow">
    <div class="float--w">
      <div class="float-tt display-600 not-display-pc">
        <span class="zh">展出作品</span>
        <span class="en"></span>
      </div>
      <div class="btn-close" @click="close()">
        <img src="@/assets/images/icon-close-blk.png" alt="close"/>
      </div>
      <div class="main-slides-w not-fix-height-resp">
        <swiper v-if="swiperOptionWorkFloat" :options="swiperOptionWorkFloat" ref="swiperTopWork">
          <swiper-slide v-for="(item,index) in artworks" :key="index">
            <artwork :info="item" @goExhibitionHandel="close"></artwork>
          </swiper-slide>
        </swiper>
        <div class="slides-navs">
          <div class="swiper-pagination swiper-pagination-work-f"></div>
          <div class="btn-nav nav-prev-work-f">
            <img src="@/assets/images/icon-ar-left-blk.png" alt="prev"/>
          </div>
          <div class="btn-nav nav-next nav-next-work-f">
            <img src="@/assets/images/icon-ar-left-blk.png" alt="prev"/>
          </div>
        </div>
      </div>
      <div class="sub-slides-w">
        <swiper v-if="swiperOptionWorkFloatThumbs" :options="swiperOptionWorkFloatThumbs" ref="swiperThumbsWork">
          <swiper-slide v-for="(item,index) in artworks" :key="index">
            <div class="bbc">
              <img class="cover" :src="item.cover.s" alt="artist"/>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>


<script>

import artwork from "./artworkInfo";

export default {
  components: {
    artwork
  },
  props: {
    index: {
      type: Number,
      default: null,
    },
    artworks: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isShow: true,
      info: null,
      swiperOptionWorkFloat: null,
      swiperOptionWorkFloatThumbs: null,
    }
  },
  mounted() {
    this.show();

    this.$nextTick(() => {
      this.swiperOptionWorkFloatThumbs = {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 64,
        slidesOffsetAfter: 64,
        centeredSlides: true,
        slideToClickedSlide: true,
        autoHeight: true,
        breakpoints: {
          1200: {
            spaceBetween: 32,
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
          },
          1600: {
            spaceBetween: 32,
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,
          }
        }
      };
      this.swiperOptionWorkFloat = {
        loop: false,
        effect: 'fade',
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination-work-f',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.nav-next-work-f',
          prevEl: '.nav-prev-work-f'
        },
      }
      setTimeout(() => {
        const swiperTopWork = this.$refs.swiperTopWork.$swiper
        const swiperThumbsWork = this.$refs.swiperThumbsWork.$swiper
        swiperThumbsWork.controller.control = swiperTopWork
        this.$refs.swiperTopWork.$swiper.slideTo(this.index, 0)
      }, 100)
    })
  },
  methods: {
    show() {
      this.isShow = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.isShow = false;
      document.body.style.overflow = "auto";
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/exhibitionArtwork.vue